import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const SubscriptionViewModule = new Module({
  id: 'subscription-view',
  name: 'Subscription',
  path: 'subscription',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Subscription/View'))
  ),
  actions: {
    approveSubscription: {
      id: 'approve-subscription',
      name: 'approve-subscription',
      label: 'Approve Subscription'
    },
    rejectSubscription: {
      id: 'reject-subscription',
      name: 'reject-subscription',
      label: 'Reject Subscription'
    },
    addSubscription: {
      id: 'add-subscription',
      name: 'add-subscription',
      label: 'Add Subscription'
    }
  }
});

export const SubscriptionAddModule = new Module({
  id: 'subscription-add',
  name: 'SubscriptionAdd',
  path: 'subscription/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Subscription/Form'))
  ),
  actions: {
    add: {
      id: 'add-subscription',
      name: 'add-subscription',
      label: 'Add Subscription'
    }
  }
});

const SubscriptionModules = [SubscriptionViewModule, SubscriptionAddModule];

export default new ModuleBundle('Subscription', SubscriptionModules);
